// This file was auto-generated by Fern from our API Definition.
export const SessionInteractionStatus = {
    Pending: "pending",
    Responded: "responded",
    Resolved: "resolved",
    Cancelled: "cancelled",
};
